/*
|--------------------------------------------------------------------------
| UI Components
|--------------------------------------------------------------------------
|
| This file contains:
| - Reusable UI widget initializers
| - DOM-driven enhancements
| - Behavior tied to specific .js-* class hooks
| - Context-aware initializers
|
| These functions should:
| - Accept $context
| - Be idempotent (safe to call multiple times)
| - Do nothing if matching elements do not exist
|
| This file should NOT contain:
| - Business logic
| - Page-specific behavior
| - Event wiring unrelated to a UI component
|
| Think: "Turn this markup into a widget."
|
*/

// Bind Components Entry Point
function BindComponents($context: JQuery<any>): void {
    InitializeJsonViewers($context);
    InitializeSummerNoteEditors($context);
}

//#region Json Pretty Print Viewers
function InitializeJsonViewers($context: JQuery<any>): void {

    if (!$context || !$context.length) {
        $context = $(document);
    }

    $context.find('.json-document').each(function (): void {

        const $pre = $(this);

        // Prevent double initialization
        if ($pre.data('jsonViewerInitialized')) {
            return;
        }

        const raw = $pre.text().trim();
        if (!raw) return;

        let input: any;

        try {
            input = JSON.parse(raw);
        }
        catch {
            input = raw; // Not valid JSON
        }

        const options = {
            collapsed: false,
            rootCollapsable: true,
            withQuotes: false,
            withLinks: true
        };

        ($pre as any).empty().jsonViewer(input, options);
        $pre.data('jsonViewerInitialized', true);
    });
}
//#endregion Json Pretty Print Viewers

//#region SummerNote Editors
function InitializeSummerNoteEditors($context: JQuery<any>): void {

    $context.findInGrid('textarea.summerNoteEditor').each(function (): void {

        const $textarea = $(this);

        // Prevent double initialization
        if ($textarea.data('summernote')) return;

        const height = getSummernoteHeight($textarea);
        const isDisabled = $textarea.prop('disabled');

        if (!isDisabled) {
            ($textarea as any).summernote({
                height,
                minHeight: null,
                maxHeight: null,
                focus: true
            });
        } else {
            ($textarea as any).summernote({
                height,
                minHeight: null,
                maxHeight: null,
                focus: true,
                toolbar: [],
                disableDragAndDrop: true,
                disableResizeEditor: true,
                disableResizeImage: true,
                dialogsInBody: true,
                callbacks: {
                    onInit: function (): void {
                        $textarea.closest('.note-editor')
                            .find('.note-editable')
                            .prop('contenteditable', false);
                    }
                }
            });
        }
    });

    function getSummernoteHeight($textarea: JQuery<any>, extraPadding: number = 10): number {

        if (!$textarea || $textarea.length === 0) return 250;

        const rows = parseInt($textarea.attr('rows') || "10");
        const lineHeight = parseInt($textarea.css('line-height') || "18");

        return rows * lineHeight + extraPadding;
    }
}
//#endregion SummerNote Editors